module.exports = __webpack_public_path__ + "static/media/jaels-creations-gif.5dcb961e.gif";